import { render } from "./index-service-termination.vue?vue&type=template&id=d6e422fa"
import script from "./index-service-termination.vue?vue&type=script&lang=js"
export * from "./index-service-termination.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apspc001/work/dev/ccc/ccc-codes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__